/* tslint:disable */
/* eslint-disable */
/**
 * leverup Service Application
 * Documentation for your application APIs v1.0
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  PagedTeamLeaderboardItem,
  PagedTeamMemberInfo,
  PagedUserTeamBoostHistory,
  TeamInfo,
  UserTeamInfo,
} from '../models/index';

export interface GetTeamBoostHistory14YxddURequest {
    userAddress: string;
    page?: number;
    size?: number;
}

export interface GetTeamGenesisAirdropLeaderboardRequest {
    epoch?: number;
    page?: number;
    size?: number;
}

export interface GetTeamInfoByCodeRequest {
    code: string;
}

export interface GetTeamMembers14YxddURequest {
    userAddress: string;
    page?: number;
    size?: number;
}

export interface GetUserTeamInfoGZuys9oRequest {
    userAddress: string;
}

/**
 * 
 */
export class GenesisAirdropControllerApi extends runtime.BaseAPI {

    /**
     */
    async getTeamBoostHistory14YxddURaw(requestParameters: GetTeamBoostHistory14YxddURequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PagedUserTeamBoostHistory>> {
        if (requestParameters['userAddress'] == null) {
            throw new runtime.RequiredError(
                'userAddress',
                'Required parameter "userAddress" was null or undefined when calling getTeamBoostHistory14YxddU().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/genesis-airdrop/{user_address}/team-boost-history`.replace(`{${"user_address"}}`, encodeURIComponent(String(requestParameters['userAddress']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getTeamBoostHistory14YxddU(requestParameters: GetTeamBoostHistory14YxddURequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PagedUserTeamBoostHistory> {
        const response = await this.getTeamBoostHistory14YxddURaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getTeamGenesisAirdropLeaderboardRaw(requestParameters: GetTeamGenesisAirdropLeaderboardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PagedTeamLeaderboardItem>> {
        const queryParameters: any = {};

        if (requestParameters['epoch'] != null) {
            queryParameters['epoch'] = requestParameters['epoch'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/genesis-airdrop/team-leaderboard`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getTeamGenesisAirdropLeaderboard(requestParameters: GetTeamGenesisAirdropLeaderboardRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PagedTeamLeaderboardItem> {
        const response = await this.getTeamGenesisAirdropLeaderboardRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getTeamInfoByCodeRaw(requestParameters: GetTeamInfoByCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TeamInfo>> {
        if (requestParameters['code'] == null) {
            throw new runtime.RequiredError(
                'code',
                'Required parameter "code" was null or undefined when calling getTeamInfoByCode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/genesis-airdrop/team-info-by-code/{code}`.replace(`{${"code"}}`, encodeURIComponent(String(requestParameters['code']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getTeamInfoByCode(requestParameters: GetTeamInfoByCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TeamInfo> {
        const response = await this.getTeamInfoByCodeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getTeamMembers14YxddURaw(requestParameters: GetTeamMembers14YxddURequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PagedTeamMemberInfo>> {
        if (requestParameters['userAddress'] == null) {
            throw new runtime.RequiredError(
                'userAddress',
                'Required parameter "userAddress" was null or undefined when calling getTeamMembers14YxddU().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/genesis-airdrop/{user_address}/team-members`.replace(`{${"user_address"}}`, encodeURIComponent(String(requestParameters['userAddress']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getTeamMembers14YxddU(requestParameters: GetTeamMembers14YxddURequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PagedTeamMemberInfo> {
        const response = await this.getTeamMembers14YxddURaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getUserTeamInfoGZuys9oRaw(requestParameters: GetUserTeamInfoGZuys9oRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserTeamInfo>> {
        if (requestParameters['userAddress'] == null) {
            throw new runtime.RequiredError(
                'userAddress',
                'Required parameter "userAddress" was null or undefined when calling getUserTeamInfoGZuys9o().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/genesis-airdrop/{user_address}/team-info`.replace(`{${"user_address"}}`, encodeURIComponent(String(requestParameters['userAddress']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getUserTeamInfoGZuys9o(requestParameters: GetUserTeamInfoGZuys9oRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserTeamInfo> {
        const response = await this.getUserTeamInfoGZuys9oRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
